import yaml from 'yaml.macro'

const de = yaml('./de.yml').de;

export default de;
